<template>
  <div class="type-selector">
    <button
      v-for="type in types"
      :key="type.objKey"
      type="button"
      class="item"
      :class="{ active: modelValue === type.objKey }"
      @click="emit('update:modelValue', type.objKey)">
      {{ type.feedbackTypeText }}
    </button>
  </div>
</template>

<script setup lang="ts">
import type { FormattedFeedbackTypeDTO } from '@/types/service'

defineProps<{
  /** 反馈类型列表 */
  types: FormattedFeedbackTypeDTO[]
  /** 当前选中的类型 objKey */
  modelValue?: number
}>()

const emit = defineEmits<{
  /** 选中某个类型 */
  (e: 'update:modelValue', objKey?: number): void
}>()
</script>

<style scoped lang="scss">
.type-selector {
  gap: 10px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: stretch;
  .item {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 5px 0;
    // width: 176px;
    justify-content: center;
    border: 0.5px solid #6c6c6c;
    border-radius: 8px;
    background: #272626;
    color: #eee;
    font-size: 13px;
    line-height: 22px;
    white-space: nowrap;
    cursor: pointer;
    text-align: center;
    transition:
      border-color 0.2s ease,
      background-color 0.2s ease;

    &:hover {
      color: #fff;
    }

    &.active {
      background: #714e23;
      border: none;
    }
  }
}
</style>
